import { useContext } from 'react';
import { ReportContext } from '../../../context/ReportContext';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import SimpleDataGrid from '../../Tables/SimpleDataGrid';
import SimpleDataGridItem from '../../Tables/SimpleDataGridItem';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

const UserMindfulnessAggregate = () => {
    const { reportData } = useContext(ReportContext);

    const meditationColumns = [
        {
            field: 'resourceTitle',
            name: 'Meditation Title',
            dataType: 'multiselect',
            styles: { minWidth: '20rem' },
        },
        { field: 'starts', name: 'Starts', dataType: 'numeric' },
        { field: 'minutesMeditated', name: 'Minutes Meditated', dataType: 'numeric' },
    ];

    const journalColumns = [
        {
            field: 'journalPrompt',
            name: 'Journal Prompt',
            dataType: 'multiselect',
            styles: { minWidth: '20rem', maxWidth: '30rem' },
        },
        { field: 'count', name: 'Total', dataType: 'numeric' },
    ];

    return (
        <div className="space-y-6">
            <div className="space-y-2">
                <h2 className="font-semibold text-slate-800">Meditations</h2>
                <SimpleDataGrid>
                    <SimpleDataGridItem
                        label="Meditation Starts:"
                        value={reportData.meditationsTotalStarts}
                    />
                    <SimpleDataGridItem
                        label="Minutes Meditated:"
                        value={reportData.meditationsTotalMinutesMeditated}
                    />
                </SimpleDataGrid>
                <StandardizedDataTable
                    data={reportData.meditations}
                    columns={meditationColumns}
                />
            </div>

            <div className="space-y-2">
                <h2 className="font-semibold text-slate-800">Journals</h2>
                <SimpleDataGrid>
                    <SimpleDataGridItem
                        label="Journals Written:"
                        value={reportData.journalsTotal}
                    />
                </SimpleDataGrid>
                <StandardizedDataTable
                    data={reportData.journals}
                    columns={journalColumns}
                />
            </div>

            <div className="space-y-2">
                <h2 className="font-semibold text-slate-800">
                    Money Mindfulness Program
                </h2>
                <SimpleDataGrid>
                    <SimpleDataGridItem
                        label="Money Mindfulness Program Starts:"
                        value={reportData.moneyMindfulnessProgramStarts}
                    />
                    <SimpleDataGridItem
                        label="Money Mindfulness Program Completions:"
                        value={reportData.moneyMindfulnessProgramCompletes}
                    />
                </SimpleDataGrid>
            </div>

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report provides an aggregate view of mindfulness activities and
                    engagement within the platform for the selected time period and
                    filters.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Meditation Starts">
                    The total number of times users started a meditation session.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Minutes Meditated">
                    The total cumulative time users spent in meditation sessions.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Journals Written">
                    The total number of journal entries created by users.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Money Mindfulness Program">
                    Tracks user engagement with the Money Mindfulness Program- a daily
                    check-in program for guiding users through various articles,
                    meditations, and journaling exercises.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserMindfulnessAggregate;
